module.exports = __webpack_public_path__ + "img/powerPlant.983e4e77.jpg";